import { render, staticRenderFns } from "./ProjectAdd.vue?vue&type=template&id=294b311f&scoped=true"
import script from "./ProjectAdd.vue?vue&type=script&lang=js"
export * from "./ProjectAdd.vue?vue&type=script&lang=js"
import style0 from "./ProjectAdd.vue?vue&type=style&index=0&id=294b311f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b311f",
  null
  
)

export default component.exports